import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../theme";
import { LanguageSelectionProps } from "./";
export type LanguageSelectionClassNames =
  | "translationBox"
  | "languageItem"
  | "languageText"
  | "languagesBox"
  | "arrowBottomIcon"
  | "languageItemSecond"
  | "languageItemStyles"
  | "languageItemClass"
  | "languageItemActive";

export type LanguageSelectionClasses = Classes<LanguageSelectionClassNames>;
export type LanguageSelectionStyles = Styles<LanguageSelectionClassNames>;
export type LanguageSelectionStylesProps = LanguageSelectionProps;

const getStyles: (theme: ThemeItem) => LanguageSelectionStyles = (
  theme: ThemeItem
) => ({
  translationBox: ({ openLanguageBox }) => ({
    background: "white",
    position: "relative",
    alignItems: "center",
    borderRadius: openLanguageBox ? "5px 5px 0 0" : 5,
    boxShadow: "0px 2px 4px #cbcbcb",
    cursor: "pointer",
    height: 29,
    width: 107,
  }),
  languageItemStyles: {
    borderRadius: 5,
    padding: [4, 10],
    display: "flex",
    alignItems: "center",
    "&:hover": {
      background: "#f3f3f3",
    },
  },
  languageItem: ({ openLanguageBox }) => ({
    extend: "languageItemStyles",
    borderRadius: openLanguageBox ? "5px 5px 0 0" : 5,
  }),
  languageItemSecond: ({ openLanguageBox }) => ({
    extend: "languageItemStyles",
    borderRadius: openLanguageBox ? "0 0 5px 5px" : 5,
  }),
  languageItemActive: ({ openLanguageBox }) => ({
    extend: "languageItemStyles",
    borderRadius: openLanguageBox ? "5px 5px 0 0" : 5,
    padding: [7, 10],
  }),
  languageItemClass: ({ openLanguageBox }) => ({
    extend: "languageItemStyles",
    borderRadius: openLanguageBox ? "0 0 5px 5px" : 5,
    padding: [7, 10],
  }),
  arrowBottomIcon: ({ openLanguageBox }) => ({
    width: 8,
    transform: openLanguageBox ? "rotate(180deg)" : "",
  }),
  languagesBox: ({ openLanguageBox }) => ({
    display: openLanguageBox ? "block" : "none",
    position: "absolute",
    background: "white",
    width: "100%",
    boxShadow: "rgb(212, 212, 212) 0px 3px 4px",
    borderTop: "solid 1px #f1f1f1",
    borderRadius: "0 0 5px 5px",
  }),
  languageText: {
    margin: [0, 10],
    color: "#707070",
    fontSize: 12,
    fontWeight: 200,
  },
});

const useLanguageSelectionStyles: (
  data?: any
) => LanguageSelectionClasses = createUseStyles<
  ThemeItem,
  LanguageSelectionClassNames
>(getStyles);

export default useLanguageSelectionStyles;
